<template>
  <div class="candidate-change-status">
    <b-modal v-model="localActive" size="custom-size" centered hide-footer hide-header @hide="closeModal">
      <template v-if="candidate">
        <svg
          class="m-candidate-status-close"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="closeModal"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
        <div class="candidate-change-status__title">Изменить статус кандидата</div>
        <div class="candidate-change-status__fullname">
          {{ candidate.fullName.value }}
        </div>
        <c-input
          v-model="form.candidateStatus"
          class="candidate-change-status__item status-select"
          :class="{
            'm-change-status-select-choice-status-required':
              form.candidateStatus === null && errorMessages.candidateStatus !== '',
          }"
          label="Статус"
          type="select"
          :items="candidateStatusesList"
          :searchable="true"
          :required="errorMessages.candidateStatus"
          :required-condition="form.candidateStatus === null"
          placeholder="Выберите статус сотрудника"
        />

        <transition name="fade">
          <c-input
            v-if="isRejectedReason"
            v-model="form.rejectionReason"
            class="candidate-change-status__item"
            floating-label="Причина отказа"
            type="select"
            :items="rejectionReasons"
            :with-special-value="true"
            :searchable="true"
            :clearable="true"
            :class="{
                'm-change-status-select-choice-status-required': errorMessages.rejectionReason,
              }"
            :required="errorMessages.rejectionReason"
            :required-condition="errorMessages.rejectionReason"
          />
        </transition>

        <transition name="fade">
          <c-input
            v-if="isAnotherRejectionReason"
            v-model="form.anotherRejectionReason"
            class="candidate-change-status__item"
            floating-label="Введите причину"
            :clearable="true"
            :class="{
              'm-change-status-select-choice-status-required':errorMessages.anotherRejectionReason
            }"
            :required-mark="true"
            :required="errorMessages.anotherRejectionReason"
            :required-condition="errorMessages.anotherRejectionReason"
          />
        </transition>

        <transition name="fade">
          <div v-if="requiresDateTimeInput" class="candidate-change-status__item datetime">
            <c-input
              ref="datepicker"
              v-model="form.date"
              class="candidate-change-status__date"
              :class="{
                'm-change-status-select-choice-status-required-datetime': errorMessages.date,
              }"
              label="Дата"
              :editable="true"
              type="date"
              format="DD.MM.YYYY, dddd"
              icon="calendar"
              placeholder="00.00.0000"
              :required="errorMessages.date"
              :required-mark="shouldDisplayRequiredMark"
              :icon-right="true"
              @invalidDate="sendErrorDateMessage"
            />
            <c-input
              v-model="form.time"
              class="candidate-change-status__time"
              :class="{
                'm-change-status-select-choice-status-required-datetime': errorMessages.time,
              }"
              label="Время"
              type="text"
              :mask="'##:##'"
              :required="errorMessages.time"
              :required-condition="errorMessages.time"
              :required-mark="shouldDisplayRequiredMark"
              placeholder="00:00"
            />
            <c-input
              v-if="isScheduledInterviewOrTestReason"
              v-model="form.filial"
              class="candidate-change-status__item place-select"
              :class="{
                'm-change-status-select-choice-status-required': form.filial === null && errorMessages.filial,
              }"
              floating-label="Место проведения"
              type="select"
              :items="filialItems"
              :searchable="true"
              :clearable="true"
              :required-mark="true"
              :required="errorMessages.filial"
              :required-condition="form.filial === null"
            />
          </div>
        </transition>

        <transition name="fade">
          <c-input
            v-if="isScheduledInterviewOrTestReason"
            v-model="form.accountable"
            class="candidate-change-status__item"
            :class="{
              'm-change-status-select-choice-status-required':
                form.accountable === null && errorMessages.accountable !== '',
            }"
            floating-label="Ответственный"
            type="select"
            :required-mark="true"
            :items="accountablePeopleAll"
            :searchable="true"
            :clearable="true"
            :required="errorMessages.accountable"
            :required-condition="form.accountable === null"
          />
        </transition>

        <transition name="fade">
          <c-input
            v-if="isInternshipedReason"
            v-model="form.filial"
            class="candidate-change-status__item"
            :class="{
              'm-change-status-select-choice-status-required': form.filial === null && errorMessages.filial,
            }"
            floating-label="Филиал"
            type="select"
            :required-mark="true"
            :items="filialItems"
            :searchable="true"
            :clearable="true"
            :required="errorMessages.filial"
            :required-condition="form.filial === null"
          />
        </transition>
        <transition name="fade">
          <div v-if="isInternshipedReason" class="candidate-change-status__position">
            <c-input
              v-model="form.position"
              class="candidate-change-status__item position-select"
              floating-label="Должность"
              type="select"
              :class="{
                'm-change-status-select-choice-status-required': errorMessages.position,
              }"
              :items="positionItems"
              :required-mark="true"
              :required="errorMessages.position"
              :required-condition="errorMessages.position"
              :searchable="true"
              :clearable="true"
            />
            <c-input
              v-if="form.position && form.position.ranks.length"
              v-model="form.rank"
              class="candidate-change-status__item rank-select"
              floating-label="Разряд"
              type="select"
              :items="form.position ? form.position.ranks : []"
              :searchable="true"
              :clearable="true"
              :required-mark="true"
              :required="errorMessages.rank"
              :required-condition="form.rank === null"
            />
          </div>
        </transition>
        <transition name="fade">
          <c-input
            v-if="isInternshipedReason"
            v-model="form.mentor"
            class="candidate-change-status__item"
            :class="{
              'm-change-status-select-choice-status-required': form.mentor === null && errorMessages.mentor !== '',
            }"
            label="Наставник"
            placeholder="Выберите сотрудника"
            type="select"
            :items="workers"
            :searchable="true"
            :clearable="true"
            :required="errorMessages.mentor"
            :required-condition="form.mentor === null"
          />
        </transition>

        <transition name="fade">
          <c-switcher
            v-if="isInternshipedReason"
            v-model="form.shouldCreateServiceUser"
            class="candidate-change-status__item"
            label="Создать пользователя сервиса"
          />
        </transition>

        <transition name="fade">
          <c-input
            v-if="isInternshipedReason && form.shouldCreateServiceUser"
            v-model="form.candidateEmail"
            class="candidate-change-status__item"
            :class="{
              'm-change-status-select-choice-status-required':
                !form.candidateEmail && errorMessages.candidateEmail !== '',
            }"
            label="Email"
            placeholder="user@example.ru"
            :clearable="true"
            :required-mark="true"
            :required="errorMessages.candidateEmail"
            :required-condition="!form.candidateEmail"
          />
        </transition>

        <c-textarea
          v-model="form.comment"
          max-length="500"
          class="candidate-change-status__item comment"
          floating-label="Комментарий"
        />
        <div class="candidate-change-status__actions">
          <c-button color="white" label="Отменить" @click="closeModal" />
          <c-button
            color="primary"
            :disabled="!form.candidateStatus"
            label="Сохранить"
            @click="changeCandidateStatus"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import Textarea from "@/components/controls/textarea";
import Switcher from "@/components/controls/switcher";

import { validateEmail } from "@/utils/text/email";
import { checkForTimeMaskValid } from "@/helpers/workWithNumbers";
import { formatCandidateForTableRecord } from "@/helpers/candidatesFunctions";

// 1: Ждёт звонка
// 2: Назначено собеседование
// 5: Принят на стажировку
// 7: Направлен на стажировку
// 4: Отказано
// 13: Кандидат отказался
// 12: Назначено тестирование

const defaultFormValues = {
  rejectionReason: null,
  anotherRejectionReason: "",
  date: "",
  time: "",
  filial: null,
  accountable: null,
  rank: null,
  candidateEmail: "",
  mentor: null,
  position: null,
  comment: "",
  shouldCreateServiceUser: false,
};

const defaultErrorValues = {
  candidateStatus: "",
  rejectionReason: "",
  anotherRejectionReason: "",
  date: "",
  time: "",
  filial: "",
  accountable: "",
  rank: "",
  candidateEmail: "",
  mentor: "",
  position: "",
};

export default {
  name: "candidate-change-status-modal",
  components: {
    "c-button": Button,
    "c-input": Input,
    "c-textarea": Textarea,
    "c-switcher": Switcher,
  },
  props: {
    candidateId: {
      type: Number,
      default: 0,
    },
    candidateData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localActive: false,
      form: {
        candidateStatus: null,
        ...defaultFormValues,
      },
      errorMessages: { ...defaultErrorValues },
      shouldEmitCancel: true,
      candidate: null,
      isSubmitted: false,
    };
  },
  computed: {
    ...mapState({
      positionItems: (state) => state.candidates.collections.positions,
      accountablePeopleAll: (state) => state.candidates.collections.accountablePeopleAll,
      filialItems: (state) => state.candidates.collections.filials,
      candidateStatusesList: (state) => state.candidates.collections.candidateStatuses,
      workers: (state) => state.candidates.collections.workers,
    }),
    ...mapGetters({
      getCandidate: "candidates/getCandidateRecordById",
      getCandidateEntity: "candidates/getCandidateById",
    }),
    isRejectedReason() {
      const rejectedStatuses = [4, 13, 10];
      return this.form.candidateStatus && rejectedStatuses.includes(this.form.candidateStatus.value);
    },
    isAnotherRejectionReason() {
      return this.isRejectedReason && this.form.rejectionReason && this.form.rejectionReason.value === "0";
    },
    isScheduledInterviewOrTestReason() {
      const statuses = [12, 2];
      return this.form.candidateStatus && statuses.includes(this.form.candidateStatus.value);
    },
    isInternshipedReason() {
      return this.form.candidateStatus && this.form.candidateStatus.value === 5;
    },
    requiresDateTimeInput() {
      const statuses = [1, 12, 2];
      return this.form.candidateStatus && statuses.includes(this.form.candidateStatus.value);
    },
    requiresDateTimeInputToBeFilled() {
      const statuses = [12, 2];
      return this.form.candidateStatus && statuses.includes(this.form.candidateStatus.value);
    },
    rejectionReasons() {
      if (!this.isRejectedReason) {
        return [];
      }
      
      return Object.entries(this.form.candidateStatus.reasons).map(([reasonId, reason]) => ({
        label: reason,
        value: reasonId,
        specialValue: reasonId === "0",
      }));
    },
    shouldDisplayRequiredMark() {
      return this.isScheduledInterviewOrTestReason;
    },
    errorConditions() {
      return {
        dateStatus: !this.form.candidateStatus,
        date: this.requiresDateTimeInputToBeFilled && !this.form.date,
        time: this.requiresDateTimeInputToBeFilled && !this.form.time,
        filial: (this.isScheduledInterviewOrTestReason || this.isInternshipedReason) && !this.form.filial,
        accountable: this.isScheduledInterviewOrTestReason && !this.form.accountable,
        rank: this.isInternshipedReason && this.form.position && this.form.position.ranks.length && !this.form.rank,
        candidateEmail: this.form.shouldCreateServiceUser && !this.form.candidateEmail,
        position: this.isInternshipedReason && !this.form.position,
        rejectionReason: this.isRejectedReason && !this.form.rejectionReason,
        anotherRejectionReason: this.isAnotherRejectionReason && !this.form.anotherRejectionReason
      };
    },
  },
  watch: {
    "form.filial": function (value) {
      if (value && this.errorMessages.filial) {
        this.errorMessages.filial = "";
      }
    },
    "form.position": function (value) {
      if (value && this.errorMessages.position) {
        this.errorMessages.position = "";
      }
    },
    "form.candidateStatus.value": function (value) {
      if (!this.localActive) {
        return;
      }
      if (value && this.errorMessages.candidateStatus) {
        this.errorMessages.candidateStatus = "";
      }
      this.resetValues();
    },
    "form.anotherRejectionReason": function (value) {
      if (value && this.errorMessages.anotherRejectionReason) {
        this.errorMessages.anotherRejectionReason = "";
      }
    },
    "form.rejectionReason": function (value, oldValue) {
      if (oldValue && oldValue.value === "0" && this.form.anotherRejectionReason) {
        this.form.anotherRejectionReason = "";
      }
    },
    "form.date": function (value) {
      if (!value) {
        return;
      }
      if (value && this.errorMessages.date) {
        this.errorMessages.date = "";
      }
      //if (!moment(value, "DD.MM.YYYY").isValid()) {
       // this.errorMessages.date = "Неверный формат";
      //}
    },
    "form.time": function (value) {
      if (!value) {
        return;
      }
      if (value && this.errorMessages.time) {
        this.errorMessages.time = "";
      }
      if (!checkForTimeMaskValid(value)) {
        //this.errorMessages.time = "Неверный формат";
      }
      if (this.isSubmitted && value.length !== 5) {
        //this.errorMessages.time = "Неверный формат";
      }
    },
    "form.candidateEmail": function (value) {
      const required = "Обязательное поле";
      if (!value) {
        this.errorMessages.candidateEmail = required;
      }
      if (value && this.errorMessages.candidateEmail === required) {
        this.errorMessages.candidateEmail = "";
      }
      if (validateEmail(value)) {
        this.errorMessages.candidateEmail = "";
        return;
      }
      this.errorMessages.candidateEmail = "Неверный формат";
    },
  },
  created() {
    if (this.candidateData) {
      this.candidate = formatCandidateForTableRecord(this.candidateData);
      
      return;
    }

    if (this.candidateId !== 0) {
      this.candidate = this.getCandidate(this.candidateId);
    }
  },
  methods: {
    setFormFields() {
      let candidateEntity;

      if (this.candidateData) {
        candidateEntity = this.candidateData;
      } else {
        candidateEntity = this.getCandidateEntity(this.candidateId);
      }

      if (candidateEntity.accountable) {
        this.form.accountable = {
          value: candidateEntity.accountable.id,
          label: candidateEntity.accountable.name,
        };
      }
      if (candidateEntity.statusTime) {
        this.form.time = candidateEntity.statusTime;
      }
      if (candidateEntity.statusDate) {
        this.form.date = candidateEntity.statusDate;
      }
      if (candidateEntity.status && candidateEntity.status.comment) {
        this.form.comment = candidateEntity.status.comment;
      }
      if (candidateEntity.filial) {
        const { id, filial_name } = candidateEntity.filial;
        this.form.filial = {
          label: filial_name,
          value: id,
        };
      }
      if (candidateEntity.post_code) {
        this.form.position = this.positionItems.find((position) => position.value === candidateEntity.post_code);
      }
      if (candidateEntity.postRank) {
        this.form.rank = {
          label: candidateEntity.postRank.rank,
          value: candidateEntity.postRank.id,
        };
      }
      if (candidateEntity.user) {
        this.form.shouldCreateServiceUser = true;
        this.form.candidateEmail = candidateEntity.user.email;
      }
      if (candidateEntity.status.reason && candidateEntity.status.reason.id) {
        this.form.rejectionReason = {
          label: candidateEntity.status.reason.name,
          value: candidateEntity.status.reason.id,
        };
      }
      if (candidateEntity.mentor) {
        this.form.mentor = {
          label: candidateEntity.mentor.name,
          value: candidateEntity.mentor.id,
        };
      }
    },
    open(status = "") {
      if (!status) {
        this.form.candidateStatus = this.candidateStatusesList.find(
          (item) => item.value.toString() === this.candidate.dateOfStatusChange.candidateStatus.value.toString(),
        );

        this.setFormFields();
      }

      if (status) {
        this.form.candidateStatus = this.candidateStatusesList.find((item) => item.value === status);
      }

      setTimeout(() => {
        this.localActive = true;
      }, 0);
      this.shouldEmitCancel = true;
    },
    resetValues() {
      this.errorMessages = { ...defaultErrorValues };
      this.form = { candidateStatus: this.form.candidateStatus, ...defaultFormValues };

      const { datepicker } = this.$refs;
      if (datepicker) {
        datepicker.clear();
      }
    },
    closeModal() {
      if (this.shouldEmitCancel) {
        this.$emit("canceled");
      }
      this.resetValues();
     // this.candidate = null;
      this.localActive = false;
    },
    sendErrorDateMessage(e) {
      if (e && this.isSubmitted)
        this.errorMessages.date = "Неверный формат";
    },
    validate() {
      let isValid = true;
      if (this.requiresDateTimeInput && (this.errorMessages.date || this.errorMessages.time)) {
        isValid = false;
      }
      Object.entries(this.errorConditions).forEach(([errorKey, errorValue]) => {
        if (errorValue) {
          isValid = false;
          this.errorMessages[errorKey] = "Обязательное поле";
        }
      });

      return isValid;
    },
    changeCandidateStatus() {
      this.isSubmitted = true;
      if (!this.validate()) {
        return;
      }
      const formValues = { candidateStoreIndex: this.candidate.storeIndex, candidateId: this.candidate.id };
      Object.entries(this.form).forEach(([formKey, formValue]) => {
        if (formValue) {
          formValues[formKey] = formValue;
        }
      });
      this.$store.dispatch("candidates/changeCandidateStatus", formValues);
      this.$emit("changed-status");
      this.shouldEmitCancel = false;
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.m-candidate-status {
  &-close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
}
.candidate-change-status {
  position: relative;

  &__title,
  &__fullname {
    font-size: 18px;
  }
  &__title {
    font-weight: 600;
  }
  &__fullname {
    margin-top: -7px;
    margin-bottom: 18px;
  }
  &__item {
    margin-bottom: 22px;

    &.comment {
      margin-top: 12px;
    }
    &.datetime {
      display: flex;

      & /deep/ .c-input-required-text {
        white-space: normal !important;
      }

      @include onlyStandartMobile {
        flex-wrap: wrap;
      }
    }
    &.place-select {
      flex-grow: 1;
      margin-bottom: 0;

      @include onlyExtraSmall {
        margin-top: 22px;
      }
    }
    &.position-select {
      width: 415px;
      margin-right: 30px;
    }
    &.rank-select {
      width: 80px;
      max-width: 80px;

      & /deep/ .c-input-container {
        width: auto;
        right: 0;
      }
      & /deep/ .c-input-required-text {
        white-space: normal !important;
      }
    }
  }
  &__date,
  &__time {
    margin-right: 30px;
    padding-top: 6px;

    @include onlyExtraSmall {
      padding-top: 0;
    }
  }
  &__date {
    width: 110px;
    @include onlyExtraSmall {
      flex-grow: 1;
    }
  }
  &__time {
    width: 65px;
    @include onlyExtraSmall {
      margin-right: 0;
    }
  }
  &__position {
    display: flex;
  }
  &__actions {
    display: flex;
    margin-top: 29px;
    justify-content: flex-end;

    @include onlyExtraSmall {
      width: 100vw;
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &::v-deep > .c-button:first-child {
      margin-right: 10px;
    }
    @media (max-width: 700px) {
      &::v-deep > .c-button {
        margin-right: 0 !important;
        border-radius: 0;
        width: 50%;
      }

      &::v-deep > .c-button > .c-button__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0 !important;
        border-radius: 0;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-change-status-select-choice-status-required {
  margin-bottom: 40px;
  &-datetime {
    margin-bottom: 20px;
  }
}

::v-deep .modal-dialog {
  max-width: 590px;
}
</style>
